import z from "zod";

export const communitySchema = z.object({
    title: z.string().min(1, { message: "제목을 입력해주세요." }).max(30, { message: "최대 30자까지 입력하실 수 있습니다." }),
    content: z.string().min(1, { message: "내용을 입력해주세요." }).max(500, { message: "최대 500자까지 입력하실 수 있습니다." }),
})